module.exports = __webpack_public_path__ + "assets/img/tit1.901312ca.png";